import { useState, useEffect, type RefObject } from 'react';

interface UseCanvasResizeProps {
  containerRef: RefObject<HTMLDivElement>;
}

interface UseCanvasResizeReturn {
  canvasSize: { width: number; height: number };
}

export const useCanvasResize = ({
  containerRef
}: UseCanvasResizeProps): UseCanvasResizeReturn => {
  const [canvasSize, setCanvasSize] = useState({ width: 800, height: 600 });

  useEffect(() => {
    const resizeCanvas = () => {
      const container = containerRef.current;
      if (!container) return;
      const width = container.clientWidth;
      const height = container.clientHeight;
      setCanvasSize({ width, height });
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);
    return () => window.removeEventListener('resize', resizeCanvas);
  }, [containerRef]);

  return {
    canvasSize
  };
};
